/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 43f96b2d (Wed Dec  3 21:51:26 UTC 2025)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  FetchBillingResponseLicensingBilling,
  FetchBillingResponseLicensingBillingFromJSON,
  FetchBillingResponseLicensingBillingInfo,
  FetchBillingResponseLicensingBillingInfoFromJSON,
  FetchBillingResponseLicensingBillingInfoToJSON,
  FetchBillingResponseLicensingBillingToJSON,
  FetchBillingResponseLicensingDirector,
  FetchBillingResponseLicensingDirectorFromJSON,
  FetchBillingResponseLicensingDirectorToJSON,
  InvoiceSignature,
  InvoiceSignatureFromJSON,
  InvoiceSignatureToJSON,
  LicensingBill,
  LicensingBillFromJSON,
  LicensingBillToJSON,
  LicensingPayment,
  LicensingPaymentFromJSON,
  LicensingPaymentToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchBillingResponseLicensing
 */
export interface FetchBillingResponseLicensing {
  /**
   * Indicates the licensing data type. 'coco' is used for country coordinators, 'lcd' is used for Licensed Community Director, and 'default' is used for all other cases.
   * @type string
   * @memberof FetchBillingResponseLicensing
   */
  variant?: FetchBillingResponseLicensingVariantEnum
  /**
   *
   * @type {Array<LicensingBill>}
   * @memberof FetchBillingResponseLicensing
   */
  programs?: Array<LicensingBill>
  /**
   *
   * @type {Array<LicensingPayment>}
   * @memberof FetchBillingResponseLicensing
   */
  history?: Array<LicensingPayment>
  /**
   *
   * @type FetchBillingResponseLicensingDirector
   * @memberof FetchBillingResponseLicensing
   */
  director?: FetchBillingResponseLicensingDirector
  /**
   *
   * @type FetchBillingResponseLicensingBilling
   * @memberof FetchBillingResponseLicensing
   */
  billing?: FetchBillingResponseLicensingBilling
  /**
   *
   * @type FetchBillingResponseLicensingBillingInfo
   * @memberof FetchBillingResponseLicensing
   */
  billingInfo?: FetchBillingResponseLicensingBillingInfo
  /**
   *
   * @type InvoiceSignature
   * @memberof FetchBillingResponseLicensing
   */
  invoiceSignature?: InvoiceSignature
}

/**
 * @export
 * @enum {string}
 */
export enum FetchBillingResponseLicensingVariantEnum {
  Default = 'default',
  Coco = 'coco',
  Lcd = 'lcd',
}

export function FetchBillingResponseLicensingFromJSON(
  json: any
): FetchBillingResponseLicensing {
  return FetchBillingResponseLicensingFromJSONTyped(json, false)
}

export function FetchBillingResponseLicensingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchBillingResponseLicensing {
  if (json === undefined || json === null) {
    return json
  }
  return {
    variant: !exists(json, 'variant') ? undefined : json['variant'],
    programs: !exists(json, 'programs')
      ? undefined
      : (json['programs'] as Array<any>).map(LicensingBillFromJSON),
    history: !exists(json, 'history')
      ? undefined
      : (json['history'] as Array<any>).map(LicensingPaymentFromJSON),
    director: !exists(json, 'director')
      ? undefined
      : FetchBillingResponseLicensingDirectorFromJSON(json['director']),
    billing: !exists(json, 'billing')
      ? undefined
      : FetchBillingResponseLicensingBillingFromJSON(json['billing']),
    billingInfo: !exists(json, 'billingInfo')
      ? undefined
      : FetchBillingResponseLicensingBillingInfoFromJSON(json['billingInfo']),
    invoiceSignature: !exists(json, 'invoiceSignature')
      ? undefined
      : InvoiceSignatureFromJSON(json['invoiceSignature']),
  }
}

export function FetchBillingResponseLicensingToJSON(
  value?: FetchBillingResponseLicensing | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    variant: value.variant,
    programs:
      value.programs === undefined
        ? undefined
        : (value.programs as Array<any>).map(LicensingBillToJSON),
    history:
      value.history === undefined
        ? undefined
        : (value.history as Array<any>).map(LicensingPaymentToJSON),
    director: FetchBillingResponseLicensingDirectorToJSON(value.director),
    billing: FetchBillingResponseLicensingBillingToJSON(value.billing),
    billingInfo: FetchBillingResponseLicensingBillingInfoToJSON(
      value.billingInfo
    ),
    invoiceSignature: InvoiceSignatureToJSON(value.invoiceSignature),
  }
}
